export default "__VITE_ASSET__B88ua0st__"